import React, {Component, ReactElement} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {
    ContentsMainTitle,
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    IconFont,
    MainContainer,
} from '../../../styledComponents/ContentsArea'
import {
    StyledAnchor,
    StyledDiv,
    StyledI,
    StyledImg,
    StyledTable,
    StyledTd,
    StyledTr,
} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {generateMedia} from 'styled-media-query'
import {BreakPoint, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {BOARD_AUTHORITY, THREAD_CATEGORY, THREAD_PRIORITY, VIEW_DO_OR_NOT} from '../../../CodeMaster'
import PreformattedDiv from '../../../styledComponents/PreformattedDiv'
import {Box} from '@mui/material'
import {
    NatGetResidentBulletinBoardThread,
    ResultData as Threadinfo,
} from '../bulletinBoard/repository/NatGetResidentBulletinBoardThread'
import {
    CommentInfo,
    NatGetResidentBulletinBoardThreadCommentList,
} from '../bulletinBoard/repository/NatGetResidentBulletinBoardThreadCommentList'
import {getFileIconPath, getThreadContributorLabel, NatAsyncCallFunction} from '../../common/util/Natutil'
import NatBulletinBoardRepo from './repository/NatBulletinBoardRepo'
import {PlainAncerLink, PlainBackLink} from '../../../styledComponents/Links'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {isIE} from 'react-device-detect'
import NatResidentImageDialogComponent from '../common/resident/NatResidentImageDialogComponent'
import {PrimaryStyledButton, SecondaryButton} from '../../../styledComponents/Button'
import {NatPutBulletinBoardThread, NatPutBulletinBoardThreadParams} from './repository/NatPutBulletinBoardThread'
import {NatPutBulletinBoardThreadCommentParams} from './repository/NatPutBulletinBoardThreadComment'
import {Messages} from '../../../Messages'
import NatDialogComponent from '../common/resident/NatDialogComponent'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {formatDateTimeForUpdateDate} from '../../../formatters/formatDate'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {Location} from 'react-router-dom'

const KEY_LOGIN_USER_ID: string = 'userId'
const KEY_BOARD_RESIDET_AUTHORITY = 'boardResidentAuthority'
const KEY_BOARD_ADMIN_AUTHORITY = 'boardAdminAuthority'


interface Props {
    threadId: number
    bulletinBoardRepo: NatBulletinBoardRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    location: Location
}


interface States {
    isLoadCompleted: boolean
    threadInfo: Threadinfo | null
    commentList: CommentInfo[]
    commentInfoTargetDeletion: CommentInfo | null
    initialMessage: string
    imageDialogOpenFlag: boolean
    imageDialogFilePath: string
    imageDialogFileName: string
    threadDeleteDialogOpenFlag: boolean
    commentDeleteDialogOpenFlag: boolean
    commentEditFlag: boolean
}

class NatResidentBulletinBoardThreadPage extends Component<Props & ResidentPagePropsSet, States> {

    boardResidentAuthority: string
    boardAdminAuthority: string

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            isLoadCompleted: false,
            threadInfo: null,
            commentList: [],
            commentInfoTargetDeletion: null,
            initialMessage: '',
            imageDialogOpenFlag: false,
            imageDialogFilePath: '',
            imageDialogFileName: '',
            threadDeleteDialogOpenFlag: false,
            commentDeleteDialogOpenFlag: false,
            commentEditFlag: false,
        }

        this.boardResidentAuthority = SessionStorageHelper.getStringItemWithDefault(KEY_BOARD_RESIDET_AUTHORITY,
            BOARD_AUTHORITY.NONE.value)
        this.boardAdminAuthority = SessionStorageHelper.getStringItemWithDefault(KEY_BOARD_ADMIN_AUTHORITY,
            BOARD_AUTHORITY.NONE.value)

        this.closeImageDialog = this.closeImageDialog.bind(this)
        this.clickThreadDeleteCancelButton = this.clickThreadDeleteCancelButton.bind(this)
        this.clickThreadDeleteOkButton = this.clickThreadDeleteOkButton.bind(this)
        this.clickThreadDeleteButton = this.clickThreadDeleteButton.bind(this)
        this.clickCommentDeleteCancelButton = this.clickCommentDeleteCancelButton.bind(this)
        this.clickCommentDeleteOkButton = this.clickCommentDeleteOkButton.bind(this)
        this.clickCommentDeleteButton = this.clickCommentDeleteButton.bind(this)
        this.clickCommentRegisterButton = this.clickCommentRegisterButton.bind(this)

    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        let initialMessage: string = ''
        let threadInfo: Nullable<Threadinfo> = null
        let commentList: Nullable<CommentInfo[]> = []
        let commentEditFlag = false


        try {

            // 現在日時取得
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await NatAsyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(
                    this.props.currentDateTimeRepo), this.props.navigate)

            // スレッド既読管理登録
            await NatAsyncCallFunction(
                this.props.bulletinBoardRepo.postBulletinBoardThreadRead.bind(
                    this.props.bulletinBoardRepo,
                    this.props.threadId,
                ), this.props.navigate)

            if (this.props.location && this.props.location.state) {
                initialMessage = this.props.location.state.initialMessage
            }

            // スレッド取得（居住者）
            const getThreadInfoResult:
                Nullable<NatGetResidentBulletinBoardThread> = await NatAsyncCallFunction(
                this.props.bulletinBoardRepo.getResidentBulletinBoardThread.bind(
                    this.props.bulletinBoardRepo,
                    this.props.threadId), this.props.navigate)
            if (getThreadInfoResult && getThreadInfoResult.details !== null) {
                threadInfo = getThreadInfoResult.details
                if (threadInfo.categoryId) {
                    if (threadInfo.categoryId === THREAD_CATEGORY.RESIDENT.value &&
                        this.boardResidentAuthority === BOARD_AUTHORITY.EDIT.value) {
                        commentEditFlag = true
                    } else if (threadInfo.categoryId === THREAD_CATEGORY.ADMIN.value &&
                        this.boardAdminAuthority === BOARD_AUTHORITY.EDIT.value) {
                        commentEditFlag = true
                    }
                }
            }

            // コメント一覧取得（居住者）
            const getCommentListResult:
                Nullable<NatGetResidentBulletinBoardThreadCommentList> = await NatAsyncCallFunction(
                this.props.bulletinBoardRepo.getResidentBulletinBoardThreadCommentList.bind(
                    this.props.bulletinBoardRepo,
                    this.props.threadId), this.props.navigate)
            if (getCommentListResult && getCommentListResult.details !== null) {
                commentList = getCommentListResult.details.commentInfo
            }


        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({
                threadInfo: threadInfo,
                commentList: commentList,
                initialMessage: initialMessage,
                isLoadCompleted: true,
                commentEditFlag,
            })
        }
    }

    clickThreadDeleteButton(): void {
        this.setState({
            initialMessage: '',
            threadDeleteDialogOpenFlag: true,
        })
    }

    // スレッド削除ボタン
    renderThreadDeleteDialog(): ReactElement | null {
        return (
            <NatDialogComponent
                open={this.state.threadDeleteDialogOpenFlag}
                params={{
                    title: '確認',
                    errorLevel: Messages.IOPCC0011.errorLevel,
                    message: Messages.IOPCC0011.toString('スレッド'),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'キャンセル',
                            buttonHandler: this.clickThreadDeleteCancelButton,
                        },
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.clickThreadDeleteOkButton,
                        },
                    ],
                }}
            />
        )
    }

    clickThreadDeleteCancelButton(): void {
        this.setState({threadDeleteDialogOpenFlag: false})
    }

    // スレッド削除処理
    async clickThreadDeleteOkButton(): Promise<void> {
        this.setState({threadDeleteDialogOpenFlag: false})
        if (this.state.threadInfo) {
            await this.props.eventEmitter.showLoading()
            const putBulletinBoardThreadParams: NatPutBulletinBoardThreadParams = {
                invisible: VIEW_DO_OR_NOT.HIDDEN.value,
                version: this.state.threadInfo.version,
            }
            try {
                const ret: Nullable<NatPutBulletinBoardThread> = await NatAsyncCallFunction(
                    this.props.bulletinBoardRepo.putBulletinBoardThread.bind(
                        this.props.bulletinBoardRepo,
                        this.props.threadId,
                        putBulletinBoardThreadParams), this.props.navigate)

                if (ret) {
                    this.props.navigate(
                        `/resident/bulletinBoardThreadList/${this.state.threadInfo.categoryId}`,
                        {state: {initialMessage: Messages.IOPCC0009.toString('スレッド')}},
                    )
                }
            } finally {
                this.props.eventEmitter.closeLoading()
            }
        }

    }


    clickCommentDeleteButton(commentInfo: CommentInfo): void {
        this.setState({
            initialMessage: '',
            commentDeleteDialogOpenFlag: true,
            commentInfoTargetDeletion: commentInfo,
        })
    }


    // コメント削除ボタン
    renderCommentDeleteDialog(): ReactElement | null {
        return (
            <NatDialogComponent
                open={this.state.commentDeleteDialogOpenFlag}
                params={{
                    title: '確認',
                    errorLevel: Messages.IOPCC0011.errorLevel,
                    message: Messages.IOPCC0011.toString('コメント'),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'キャンセル',
                            buttonHandler: this.clickCommentDeleteCancelButton,
                        },
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.clickCommentDeleteOkButton,
                        },
                    ],
                }}
            />
        )
    }

    clickCommentDeleteCancelButton(): void {
        this.setState({
            commentInfoTargetDeletion: null,
            commentDeleteDialogOpenFlag: false,
        })
    }

    // コメント削除処理
    async clickCommentDeleteOkButton(): Promise<void> {
        this.setState({commentDeleteDialogOpenFlag: false})
        if (this.state.commentInfoTargetDeletion) {
            await this.props.eventEmitter.showLoading()
            const putBulletinBoardThreadCommentParams: NatPutBulletinBoardThreadCommentParams = {
                invisible: VIEW_DO_OR_NOT.HIDDEN.value,
                version: this.state.commentInfoTargetDeletion.version,
            }
            try {
                const ret: Nullable<NatPutBulletinBoardThread> = await NatAsyncCallFunction(
                    this.props.bulletinBoardRepo.putBulletinBoardThreadComment.bind(
                        this.props.bulletinBoardRepo,
                        this.props.threadId,
                        this.state.commentInfoTargetDeletion.commentId,
                        putBulletinBoardThreadCommentParams), this.props.navigate)

                if (ret) {
                    this.props.navigate(this.props.location.pathname, {
                        state: {
                            initialMessage: Messages.IOPCC0009.toString('コメント'),
                        },
                    })
                    window.location.reload()
                }
            } finally {
                this.props.eventEmitter.closeLoading()
            }
        }
    }


    clickCommentRegisterButton(): void {
        if (this.state.threadInfo) {
            this.props.navigate(`/resident/bulletinBoardThreadCommentRegister/${this.state.threadInfo.categoryId}/${this.props.threadId}`)
        } else {
            this.props.navigate(`/resident/error`)
        }
    }

    openImageDialog(imageDialogFilePath: string, imageDialogFileName: string): void {
        this.setState({
            imageDialogOpenFlag: true,
            imageDialogFilePath: imageDialogFilePath,
            imageDialogFileName: imageDialogFileName,
        })
    }

    closeImageDialog(): void {
        this.setState({imageDialogOpenFlag: false})
    }


    getFileLink(fileName: string, filePath: string, fileNameExtension: string): ReactElement {
        switch (fileNameExtension.toUpperCase()) {
            case 'PDF':
                if (isIE) {
                    return (
                        <PlainAncerLinkUnderLine
                            onClick={() => window.open(filePath)}
                            target={'_blank'}>
                            <StyledFileTd>
                                <StyledFileIcon
                                    src={getFileIconPath(fileNameExtension)}
                                    alt={fileName}
                                />
                            </StyledFileTd>
                            <StyledFileNameTd>{fileName}</StyledFileNameTd>
                        </PlainAncerLinkUnderLine>
                    )
                    break
                } else {
                    return (
                        <PlainAncerLinkUnderLine href={filePath} target={'_blank'}>
                            <StyledFileTd>
                                <StyledFileIcon src={getFileIconPath(fileNameExtension)}
                                                alt=""/>
                            </StyledFileTd>
                            <StyledFileNameTd>{fileName}</StyledFileNameTd>
                        </PlainAncerLinkUnderLine>
                    )
                    break
                }

            default:
                return (
                    <PlainAncerLinkUnderLine href={filePath} download>
                        <StyledFileTd>
                            <StyledFileIcon src={getFileIconPath(fileNameExtension)}
                                            alt=""/>
                        </StyledFileTd>
                        <StyledFileNameTd>{fileName}</StyledFileNameTd>
                    </PlainAncerLinkUnderLine>
                )
                break
        }
    }

    renderCommentInfo(commentInfo: CommentInfo): Nullable<ReactElement> {
        return (
            <CommentInfoBlock>
                <CommnetInfoLow>
                    <CommnetContributor>
                        {getThreadContributorLabel(commentInfo.contributorRidgeName,
                            commentInfo.contributorRoomNumber,
                            commentInfo.contributorFamilyName,
                            commentInfo.contributorFirstName,
                            commentInfo.contributorRoleName)}
                    </CommnetContributor>
                    <CommnetUpdatetime>
                        {formatDateTimeForUpdateDate(`${commentInfo.updateDatetime}+09:00`)}
                    </CommnetUpdatetime>
                </CommnetInfoLow>
                <Box mt={'8px'}>
                    <div dangerouslySetInnerHTML={{__html: commentInfo.comment}}/>
                </Box>

                {(commentInfo.commentToFileImage.length > 0) ?
                    <Box mt={'8px'}>
                        <ImageListFlex>
                            <ImageList>
                                {commentInfo.commentToFileImage.map((commentImage, key) => (
                                    <ImageDiv key={key}>
                                        <ImageLink
                                            onClick={() =>
                                                this.openImageDialog(commentImage.path, commentImage.fileName)}>
                                            <ImageImg src={`${commentImage.path}?${new Date().getTime()}`}/>
                                        </ImageLink>
                                    </ImageDiv>
                                ))}
                            </ImageList>
                        </ImageListFlex>
                    </Box> : <></>
                }

                {(commentInfo.commentToFileOther.length > 0) ?
                    <Box mt={'8px'}>
                        <StyledFileTable>
                            {commentInfo.commentToFileOther.map((commentFile) => {
                                return (
                                    <>
                                        <StyledFileTr>
                                            {this.getFileLink(commentFile.fileName,
                                                commentFile.path,
                                                commentFile.fileNameExtension)}
                                        </StyledFileTr>
                                    </>
                                )
                            })}
                        </StyledFileTable>
                    </Box> : <></>
                }
                {(commentInfo.userId === SessionStorageHelper.getStringItemWithDefault(KEY_LOGIN_USER_ID, '')) ?
                    <Box mt={'8px'}>
                        <SecondaryButton
                            onClick={() => this.clickCommentDeleteButton(commentInfo)}
                            disabled={false}>
                            コメント削除
                        </SecondaryButton>
                    </Box> : <></>
                }
            </CommentInfoBlock>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        if (!this.state.threadInfo) {
            return null
        }

        let subTitle: string = ''
        const threadCategoryCode: THREAD_CATEGORY =
            THREAD_CATEGORY.codeToEnumConstants(this.state.threadInfo.categoryId)
        if (threadCategoryCode) {
            subTitle = threadCategoryCode.label
        }

        return <>
            <NatResidentImageDialogComponent
                open={this.state.imageDialogOpenFlag}
                closeImageDialog={this.closeImageDialog}
                imagePath={this.state.imageDialogFilePath}
                imageFileName={this.state.imageDialogFileName}
                navigate={this.props.navigate}
                location={this.props.location}
                eventEmitter={this.props.eventEmitter}
            />
            <ContentsMainTitle><TitleIcon/>情報交換掲示板</ContentsMainTitle>
            <ContentsSubTitleWrapper>
                <ContentsSubTitleInner>
                    {subTitle}
                </ContentsSubTitleInner>
            </ContentsSubTitleWrapper>

            {(this.state.initialMessage) ?
                <InitialMessage>
                    {this.state.initialMessage}
                </InitialMessage> : <></>
            }

            <MainContainer>
                <ThreadFlex>
                    <ThreadIconFlex>
                        {(this.state.threadInfo.priority === THREAD_PRIORITY.IMPORTANT.value) ?
                            <ThreadIconImportantStyle><ThreadTableCellIcon/></ThreadIconImportantStyle> :
                            <ThreadIconNormalStyle><ThreadTableCellIcon/></ThreadIconNormalStyle>
                        }
                    </ThreadIconFlex>
                    <ThreadInfoFlex>
                        <ThreadInfoTitleFlex>
                            {this.state.threadInfo.title}
                        </ThreadInfoTitleFlex>

                        <ThreadInfosFlex>
                            <ThreadInfoOthre>
                                <ThreadInfoContributor>
                                    {getThreadContributorLabel(this.state.threadInfo.contributorRidgeName,
                                        this.state.threadInfo.contributorRoomNumber,
                                        this.state.threadInfo.contributorFamilyName,
                                        this.state.threadInfo.contributorFirstName,
                                        this.state.threadInfo.contributorRoleName)}
                                </ThreadInfoContributor>
                                <ThreadInfoUpdateDatetime>
                                    {`${formatDateTimeForUpdateDate(`${this.state.threadInfo.updateDatetime}+09:00`)} 更新`}
                                </ThreadInfoUpdateDatetime>
                                <ThreadInfoNumbers>
                                    {`返信：${this.state.threadInfo.replyCount}　既読：${this.state.threadInfo.alreadyReadCount}`}
                                </ThreadInfoNumbers>
                            </ThreadInfoOthre>
                        </ThreadInfosFlex>
                    </ThreadInfoFlex>
                </ThreadFlex>

                <Box mt={'8px'}>
                    <div dangerouslySetInnerHTML={{__html: this.state.threadInfo.detail}}/>
                </Box>

                {(this.state.threadInfo.threadToFileImage.length > 0) ?
                    <Box mt={'8px'}>
                        <ImageListFlex>
                            <ImageList>
                                {this.state.threadInfo.threadToFileImage.map((threadImage, key) => (
                                    <ImageDiv>
                                        <ImageLink
                                            onClick={() =>
                                                this.openImageDialog(threadImage.path, threadImage.fileName)}>
                                            <ImageImg src={`${threadImage.path}?${new Date().getTime()}`}/>
                                        </ImageLink>
                                    </ImageDiv>
                                ))}
                            </ImageList>
                        </ImageListFlex>
                    </Box> : <></>
                }

                {(this.state.threadInfo.threadToFileOther.length > 0) ?
                    <StyledFileTable>
                        {this.state.threadInfo.threadToFileOther.map((threadFile) => {
                            return (
                                <>
                                    <StyledFileTr>
                                        {this.getFileLink(threadFile.fileName,
                                            threadFile.path,
                                            threadFile.fileNameExtension)}
                                    </StyledFileTr>
                                </>
                            )
                        })}
                    </StyledFileTable> : <></>
                }
                {(this.state.threadInfo.userId ===
                    SessionStorageHelper.getStringItemWithDefault(KEY_LOGIN_USER_ID, '')) ?
                    <Box padding={'15px 0 15px 0'}>
                        <SecondaryButton
                            onClick={this.clickThreadDeleteButton}
                            disabled={false}>
                            スレッド削除
                        </SecondaryButton>
                    </Box> : <></>
                }

                {(this.state.commentList.length > 0) ?
                    <CommentList>
                        {this.state.commentList.map((commentInfo) =>
                            this.renderCommentInfo(commentInfo),
                        )}
                    </CommentList> : <></>
                }


            </MainContainer>
            {(this.state.commentEditFlag) ?
                <Box padding={'15px 0 15px 0'}>
                    <PrimaryStyledButton
                        onClick={this.clickCommentRegisterButton}
                        disabled={false}>
                        コメント投稿
                    </PrimaryStyledButton>
                </Box>
                : <></>
            }

            {this.renderThreadDeleteDialog()}
            {this.renderCommentDeleteDialog()}
            <BlockSpacer height={'20px'}/>
            <PlainBackLink to={`/resident/bulletinBoardThreadList/${this.state.threadInfo.categoryId}`}>
                スレッド一覧へ戻る
            </PlainBackLink>
            <BlockSpacer height={'15px'}/>
        </>
    }
}

export default createResidentPage(NatResidentBulletinBoardThreadPage)

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

const TitleIcon: StyledI = styled.i`
  ${IconFont};
  font-size: 6.0rem;
  padding-right: 15px;
  color: #4dba78;

  &::before {
      content: "\f111";
  }
`

export const InitialMessage = styled(PreformattedDiv)`
  background-color: rgb(0, 131, 138);
  color: white;
  font-weight: ${FontWeights.Bold};
  font-size: ${FontSize.Body};
  padding: 10px;
`


const ThreadIconStyle: StyledDiv = styled.div`
  ${IconFont};
  font-size: 6.0rem;
  padding-right: 15px;
  color: white;
  ${breakPoint.lessThan('sp')`
    padding-right: 12.5px;
    font-size: 5.5rem;
  `}
`

const ThreadIconNormalStyle = styled(ThreadIconStyle)`
  background-color: grey;

`
const ThreadIconImportantStyle = styled(ThreadIconStyle)`
  background-color: red;
`

const ThreadTableCellIcon: StyledI = styled.i`
  &::before {
      content: "\f111";
  }
`

const StyledFileTable: StyledTable = styled.table`
  border: none;
  word-break: break-all;
`
const StyledFileTr: StyledTr = styled.tr`
  border: none;
`
const StyledFileTd: StyledTd = styled.td`
  border: none;
`

const StyledFileNameTd = styled(StyledFileTd)`
  vertical-align: middle;
  text-align: left;
`

const PlainAncerLinkUnderLine = styled(PlainAncerLink)`
  text-decoration: underline;
  cursor: pointer;
`


const StyledFileIcon: StyledImg = styled.img`
  max-height: 80px;
`

const CommentList: StyledDiv = styled.div`

`

const CommentInfoBlock: StyledDiv = styled.div`
  margin: 10px 0px;
  border-width: 2px;
  border-style: solid;
  border-color: grey;
  border-image: initial;
  border-radius: 8px;
  padding: 8px;
`

const CommnetInfoLow: StyledDiv = styled.div`
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  flex-wrap: nowrap;
  box-sizing: border-box;
  flex-direction: row;
  -webkit-box-align: center;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid grey;
`

const ThreadFlex: StyledDiv = styled.div`
  padding: 8px 0;
  display: flex;
`

const ThreadIconFlex: StyledDiv = styled.div`
`

const ThreadInfoFlex: StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 15px;
`

const ThreadInfoTitleFlex: StyledDiv = styled.div`
  font-size: 2.2rem;
  display: flex;
  ${breakPoint.lessThan('sp')`
    font-size: 2.0rem;
  `}
`

const ThreadInfosFlex: StyledDiv = styled.div`
  font-size: 1.1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  ${breakPoint.lessThan('sp')`
    font-size: 1rem;
  `}
`

const ThreadInfoOthre: StyledDiv = styled.div`
  display: flex;
  width: 100%;
  ${breakPoint.lessThan('sp')`
    display: flex;
    flex-direction: column;
  `}
`

const ThreadInfoContributor: StyledDiv = styled.div`
  flex-basis: 50%;
  ${breakPoint.lessThan('sp')`
    flex-basis: 100%;
 `}
`

const ThreadInfoUpdateDatetime: StyledDiv = styled.div`
  flex-basis: 25%;
  ${breakPoint.lessThan('sp')`
    flex-basis: 100%;
 `}
`

const ThreadInfoNumbers: StyledDiv = styled.div`
  flex-basis: 25%;
  text-align: center;
  ${breakPoint.lessThan('sp')`
    flex-basis: 100%;
    text-align: left;
 `}
`

const CommnetContributor: StyledDiv = styled.div`
  font-size: 1.1rem;
`

const CommnetUpdatetime: StyledDiv = styled.div`
  font-size: 1.1rem;
`

const ImageListFlex: StyledDiv = styled.div`
  display: flex;
`

const ImageList: StyledDiv = styled.div`
  width: 100%;
  float: left;
`

const ImageDiv: StyledDiv = styled.div`
  display: inline;
  width: calc(100% / 4);
  padding: 8px;
  box-sizing: border-box;
  float: left;
  ${breakPoint.lessThan('sp')`
    width: 100%;
 `}
`

const ImageImg: StyledImg = styled.img`
  max-width: 100%;
  height: auto;
`

const ImageLink: StyledAnchor = styled.a`
  cursor: pointer;
`
